import { supabase } from "../supabaseClient";

// Små lärarinställningar som ska följa kontot (inte bara webbläsaren): om
// introduktionen är visad och vilken nyhet man senast läst. De sparas i
// user_metadata, som klienten själv får skriva — ingen tabell eller migration
// behövs. localStorage är en snabbkopia, så att valet gäller direkt även innan
// kontot hunnit uppdateras (och om uppdateringen misslyckas).

const localKey = (userId, key) => `trat.pref.${userId}.${key}`;

export function getPref(user, key) {
  if (!user) return undefined;
  const meta = user.user_metadata?.[key];
  if (meta !== undefined) return meta;
  try {
    const v = localStorage.getItem(localKey(user.id, key));
    return v === null ? undefined : JSON.parse(v);
  } catch {
    return undefined;
  }
}

export async function setPref(user, key, value) {
  if (!user) return;
  try { localStorage.setItem(localKey(user.id, key), JSON.stringify(value)); } catch { /* privat läge */ }
  try {
    await supabase.auth.updateUser({ data: { [key]: value } });
  } catch { /* lokalkopian räcker tills vidare */ }
}
